import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import SoftTypography from "components/SoftTypography";

function CreateTemplate({ id, name, showModal, signalCloseModal }) {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("create");
  const [showError, setShowError] = useState(false);

  const handleCancelCreation = () => {
    setOpen(false);
    signalCloseModal(false, null);
  };

  const handleCreation = () => {
    if (document.getElementById("create-template-input").value == "") {
      showErrorHandle();
      return;
    }
    setOpen(false);
    signalCloseModal(true, mode, document.getElementById("create-template-input").value);
  };

  const showErrorHandle = () => {
    setShowError(true);
  };

  const checkErrorHandle = () => {
    if (document.getElementById("create-template-input").value != "") {
      setShowError(false);
    } else {
      setShowError(true);
    }
  };

  useEffect(() => {
    setOpen(showModal);
  }, [showModal]);

  useEffect(() => {
    if (name) {
      setMode("edit");
    } else {
      setMode("create");
    }
  }, [id, name]);

  return (
    <div>
      <Dialog open={open} onClose={handleCancelCreation}>
        <DialogTitle>{name ? "Change Template Name" : "Create New Template"}</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ marginBottom: 10 }}>
            {name
              ? "Change the Name on the selected Template in order to Regognise it better in the list of your Available Templates."
              : "Give a Name on the Template you want to Create in order to Regognise it better in the list of your Available Templates."}
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="create-template-input"
            label="Template Name"
            type="text"
            fullWidth
            variant="standard"
            defaultValue={name}
            error={showError}
            onChange={checkErrorHandle}
          />
          <SoftTypography
            variant="caption"
            color="error"
            style={{ display: showError ? "" : "none" }}
          >
            Please Complete the Template Name.
          </SoftTypography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelCreation}>Cancel</Button>
          <Button onClick={handleCreation}>{name ? "Save" : "Create"}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

// Setting default values for the props of CreateTemplate
CreateTemplate.defaultProps = {
  showModal: true,
  signalCloseModal: () => {
    //console.log("close Modal");
  },
};

// Typechecking props of the CreateTemplate
CreateTemplate.propTypes = {
  id: PropTypes.number,
  name: PropTypes.string,
  showModal: PropTypes.bool,
  signalCloseModal: PropTypes.func,
};

export default CreateTemplate;
